import Button from "@components/Button";
import { useTranslation } from "next-i18next";
import { PurchaseIntroductionStepTileContent } from "@modules/purchase/types/PurchaseIntroductionStepTileContent";
import { ReactElement } from "react";

type Props = {
  stepTiles: PurchaseIntroductionStepTileContent[];
  handleOnGetStartedClick?: () => void;
  headerImageElement?: ReactElement;
  headerText: string;
  introText: string;
  purchaseType: "warranty" | "c2c"; // At some point c2c intro page will also be removed and be used on Summary side pane instead, and so styling will be identical for both warranty and c2c
};
const PurchaseIntroduction = ({
  stepTiles,
  handleOnGetStartedClick,
  headerImageElement,
  headerText,
  introText,
  purchaseType,
}: Props) => {
  const { t } = useTranslation(["common", "purchase"]);

  return (
    <>
      {purchaseType === "c2c" && (
        <>
          {headerImageElement}
          <h1 className="mt-8 mb-4 text-3xl sm:text-4xl">{headerText}</h1>
          <h4 className="mb-8 max-w-4xl text-center">{introText}</h4>
          <div className="flex flex-col sm:flex-wrap sm:flex-row justify-center gap-6 sm:gap-4">
            {stepTiles.map((step, index) => (
              <div
                key={step.title}
                className="sm:basis-2/5 md:basis-1/4 xl:basis-auto px-4 py-5 sm:w-48 border rounded-lg border-gray-200"
              >
                <div className="md:block flex mb-2">
                  <h1 className="mr-4">{index + 1}</h1>
                  <div className="flex flex-col">
                    <h5>{step.title}</h5>
                    {!!step.duration && (
                      <p className="body-3 text-primary-bold">
                        {step.duration}
                      </p>
                    )}
                  </div>
                </div>
                <p className="caption-2">{step.description}</p>
              </div>
            ))}
          </div>
          <Button
            className="mt-8 w-full sm:w-auto"
            onClick={handleOnGetStartedClick}
          >
            {t("common:get_started")}
          </Button>
        </>
      )}
      {purchaseType === "warranty" && (
        <>
          <h3 className="pt-[34px] lg:mt-8 mb-4 text-center">{headerText}</h3>
          <h6 className="mb-8 pt-[12px] pb-[16px] max-w-4xl text-center">
            {introText}
          </h6>
          <div className="flex flex-col justify-center lg:gap-6 gap-4">
            {stepTiles.map((step, index) => (
              <div
                key={step.title}
                className="px-4 py-5 border rounded-lg border-gray-200"
              >
                <div className="flex items-center mb-2">
                  <h1 className="font-semibold mr-4">{index + 1}</h1>
                  <h5>{step.title}</h5>
                </div>
                <p className="body-4">{step.description}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};
export default PurchaseIntroduction;
